import { render, staticRenderFns } from "./CreateLink.vue?vue&type=template&id=a62096a6&scoped=true"
import script from "./CreateLink.vue?vue&type=script&lang=js"
export * from "./CreateLink.vue?vue&type=script&lang=js"
import style0 from "./CreateLink.vue?vue&type=style&index=0&id=a62096a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62096a6",
  null
  
)

export default component.exports